var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    fillRule: "nonzero",
    d: "M15.134 3.721a3.074 3.074 0 0 0-1.14-2.098C12.589.477 10.58.647 9.5 1.968L3.265 9.646a1.86 1.86 0 0 0-.392 1.423c.067.507.326.952.736 1.295l.07.064c.386.305.88.467 1.385.416.503-.05.945-.293 1.27-.691l3.945-4.88a.673.673 0 0 0 .143-.483.639.639 0 0 0-.243-.442.673.673 0 0 0-.483-.144.639.639 0 0 0-.442.243l-3.945 4.881a.598.598 0 0 1-.39.22.561.561 0 0 1-.434-.133l-.07-.063a.651.651 0 0 1-.257-.462.514.514 0 0 1 .115-.422l6.235-7.679c.626-.767 1.827-.846 2.664-.157.37.302.616.729.653 1.214a1.77 1.77 0 0 1-.389 1.324l-6.321 7.793a3.161 3.161 0 0 1-2.134 1.15 3.126 3.126 0 0 1-2.317-.698c-.599-.478-.939-1.187-.997-1.988-.055-.817.216-1.62.743-2.292l5.379-6.413a.65.65 0 0 0-.567-1.065.67.67 0 0 0-.44.227L1.414 8.331C.673 9.258.29 10.385.378 11.538a3.985 3.985 0 0 0 1.477 2.905c.57.456 1.247.785 1.96.924.429.083.87.104 1.323.06a4.348 4.348 0 0 0 3-1.623l6.308-7.812a3.08 3.08 0 0 0 .689-2.27z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttachment);
export default __webpack_public_path__ + "static/media/file-attachment.c8f2c4865f641ab6cc6e9ee66abb6dd2.svg";
export { ForwardRef as ReactComponent };